<template>
  <v-container class="mx-0 px-0">
   <span style="font-size: 20px;"><b>{{ fieldLabel }}</b></span>
   <v-card elevation="2" class="my-8 mx-0 px-2">
      <v-card-text>
         <v-row>
            <v-col
            v-for="(item, index) in galleryList"
            :key="index"
            cols="6"
            sm="6"
            md="4"
            lg="3"
            >
            <v-card
              v-if="item.picture"
               class="pa-2 theme-card"
               outlined
               :style="selectedIndex === index || parseInt(localImageIndex) === index ? 'border: 2px solid #7C4DFF' : ''"
               @click="selectTheme(index)"
            >
               <v-img
                  :src="item.picture"
                  height="200"
                  class="rounded"
                  contain
                  @click="openGalleryDialog(index)"
               ></v-img>
               <v-card-text class="text-center font-weight-medium pt-4">
                  <div style="font-size: 1.2rem;">{{ languageSelect === 0 ? item.nameTH  : item.nameEN }}</div>
               </v-card-text>
            </v-card>
            </v-col>
         </v-row>
      </v-card-text>
   </v-card>

   <!-- Gallery Dialog -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title class="justify-space-between">
          <span class="text-h6">{{selectedGallery.nameTH}}</span>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-5">
          <v-row>
            <v-col
              v-for="(img, i) in selectedGallery.gallery"
              :key="i"
              cols="6"
              sm="6"
              md="4"
            >
              <v-img :src="img" aspect-ratio="1" class="rounded" @click="viewFullImage(img)"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
         <v-row class="mt-4">
            <v-col cols="6" class="text-left">
               <v-btn  color="secondary" @click="dialog = false">
                  ย้อนกลับ
               </v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
               <v-btn  color="primary" @click="selectTheme(selectedIndex), dialog = false">
                  ปิด
               </v-btn>
            </v-col>
         </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog: Full Image View -->
    <v-dialog v-model="showFullImage" max-width="90vw">
      <v-card>
        <v-card-title class="justify-space-between">
          <span class="text-h6"></span>
          <v-btn icon @click="showFullImage = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="d-flex justify-center">
          <v-img :src="selectedImage" max-width="100%" max-height="80vh" contain />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'StudioThemeList',
  props: {
    galleryList: {
      type: Array,
      required: true
    },
    fieldLabel: {
      type: String,
      required: true
    },
    fieldId: {
      type: [String, Number],
      required: true
    },
    languageSelect: {
      type: [String, Number],
      required: true
    },
    imageSelectIndex: {
      type: [String, Number],
      required: false
    }
  },
  data () {
    return {
      selectedIndex: null,
      selectedGallery: [],
      dialog: false,
      showFullImage: false,
      selectedImage: '',
      localImageIndex: this.imageSelectIndex
    }
  },
  methods: {
    selectTheme (index) {
      this.localImageIndex = ''
      this.selectedIndex = index
      this.$emit('select-theme', {
        fieldId: this.fieldId,
        fieldLabel: this.galleryList[index].nameTH,
        index: index
      })
    },
    openGalleryDialog (index) {
      this.selectedIndex = index
      this.selectedGallery = this.galleryList[index]
      this.dialog = true
    },
    viewFullImage (imageUrl) {
      this.selectedImage = imageUrl
      this.showFullImage = true
    }
  }
}
</script>

<style scoped>
.theme-card {
  border-radius: 12px;
  transition: all 0.2s ease;
  cursor: pointer;
}
.selected-card {
  border: 2px solid #7C4DFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/ComponentImage.vue